import React, {Component} from 'react';
import {Row, Col, Card, Button, Modal, Form, Input, Checkbox, Drawer, Spin} from 'antd';
import {app, config} from '../../app';
import IInform from './IInform';
import {getInsuraOrderFormDetail, insuraOrderSubmit, insuraOrderPay} from './insure_api';
import icp_png from '../../assets/ICP.jpeg';

const FormItem = Form.Item;

class IBuy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail_visible: false,
      inform_visible: false,
      informData: {},
      insurance_info: {},
      volunteer_info: {},
      data_loading: true,
      tongyi: false
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    const data = await getInsuraOrderFormDetail();
    if (data) {
      await this.setData({...data, data_loading: false});
    } else {
      this.props.history.go(-1);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 打开详情
   * @returns {Promise<void>}
   */
  handleOpenDetail = async () => {
    await this.setData({detail_visible: true});
  };

  /**
   * 打开投保告知
   * @returns {Promise<void>}
   */
  handleOpenInform = async () => {
    await this.setData({inform_visible: true});
  };

  /**
   * 同意变更
   * @returns {Promise<void>}
   */
  handleTYChange = async (e) => {
    if (e.target.checked) {
      await this.handleOpenInform();
    } else {
      await this.setData({tongyi: false});
    }
  };

  /**
   * 提交
   **/
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        if (!this.state.tongyi) {
          app.alert('请先阅读保险告知', 'warn');
          return false;
        }
        await this.setData({submit_loading: true});
        const params = {...values};
        let data = await insuraOrderSubmit(params);
        if (data) {
          await insuraOrderPay(data.id, () => {
            this.props.history.push('/insure/orders');
          });
        }
        await this.setData({submit_loading: false});
      }
    });
  };

  render() {
    let {getFieldDecorator} = this.props.form, formItemLayout = {
      labelCol: {span: 4},
      wrapperCol: {span: 6}
    };
    let {detail_visible, inform_visible, insurance_info, volunteer_info, data_loading, submit_loading, tongyi} = this.state;
    return (
      <div className="insure-buy-page insure-details-page">
        <div className="idp-body">
          <Spin tip="正在加载数据..." spinning={data_loading} size="large">

            <Card className="pb-card" size="small">
              <div className="pb-info">
                <div className="bi-img">
                  <img src={insurance_info.avatar} alt=""/>
                </div>
                <div className="bi-names">
                  <div className="in-1">{insurance_info.name}</div>
                </div>
                {/*<div className="i-link" onClick={this.handleOpenDetail}>产品详情 》</div>*/}
                <a target="_blank" href={config.imgUrl + insurance_info.product_setting} className="i-link">产品详情 》</a>
              </div>
            </Card>
            <Card className="pb-card" size="small">
              <Row>
                <Col span={8}>保单生效日</Col>
                <Col span={16} style={{textAlign: 'right'}}>{insurance_info.inforce_date}</Col>
              </Row>
              <Row>
                <Col span={8}>保单届满日</Col>
                <Col span={16} style={{textAlign: 'right'}}>{insurance_info.expire_date}</Col>
              </Row>
              <Row>
                <Col span={8}>保险期间</Col>
                <Col span={16} style={{textAlign: 'right'}}>{insurance_info.insur_dur}</Col>
              </Row>
            </Card>
            <Card className="pb-card" size="small" title="保障项目" extra={<span>保额（元）</span>}>
              {
                insurance_info.benefits && insurance_info.benefits.length ? insurance_info.benefits.map((b, i) => (
                  <Row key={'amount' + i}>
                    <Col span={8}>{b.name}</Col>
                    <Col span={16} style={{textAlign: 'right'}}>{b.amount}</Col>
                  </Row>
                )) : <span> - </span>
              }
            </Card>
            <Card className="pb-card" size="small" title="保险费"
                  extra={<span>{insurance_info.fixed_premium}元</span>}
                  bodyStyle={{padding: 0}}/>
            <Form {...formItemLayout} onSubmit={this.handleSubmit}>
              <Card className="pb-card" size="small" title="投保人信息">
                <Form.Item label="投保人姓名">
                  <span className="ant-form-text">{volunteer_info.name}</span>
                </Form.Item>
                <Form.Item label="投保人身份证号码">
                  <span className="ant-form-text">{volunteer_info.idno}</span>
                </Form.Item>
                <FormItem label="投保人手机号码">
                  {getFieldDecorator('mobile', {
                    rules: [
                      {
                        required: true,
                        pattern: /^[0-9]{11}$/,
                        message: '投保人手机号码必须填写',
                      },
                    ],
                    initialValue: volunteer_info.mobile
                  })(<Input placeholder="必填"/>)}
                </FormItem>
                <FormItem label="投保人电子邮箱">
                  {getFieldDecorator('email', {initialValue: volunteer_info.email})
                  (<Input placeholder="选填"/>)}
                </FormItem>
              </Card>
              <Card className="pb-card" size="small" title="被保人信息">
                <Form.Item label="被保人是投保人的（关系）">
                  <span className="ant-form-text">本人</span>
                </Form.Item>
                {/*<FormItem label="被保人是投保人的（关系）">*/}
                {/*{getFieldDecorator('guanxi', {*/}
                {/*rules: [*/}
                {/*{*/}
                {/*required: true,*/}
                {/*message: '被保人与投保人关系不正确',*/}
                {/*},*/}
                {/*],*/}
                {/*initialValue: '1'*/}
                {/*})(*/}
                {/*<Select placeholder="请选择">*/}
                {/*<Option value="1">本人</Option>*/}
                {/*/!*<Option value="2">配偶</Option>*!/*/}
                {/*/!*<Option value="3">父母</Option>*!/*/}
                {/*/!*<Option value="4">子女</Option>*!/*/}
                {/*</Select>*/}
                {/*)}*/}
                {/*</FormItem>*/}
                {/*{*/}
                {/*formData.bGuanxi !== '1' ? (<div>*/}
                {/*<FormItem label="被保人姓名">*/}
                {/*{getFieldDecorator('bName', {*/}
                {/*rules: [*/}
                {/*{*/}
                {/*required: true,*/}
                {/*message: '被保人姓名必须填写',*/}
                {/*},*/}
                {/*],*/}
                {/*})(<Input placeholder="必填"/>)}*/}
                {/*</FormItem>*/}
                {/*<FormItem label="被保人身份证号码">*/}
                {/*{getFieldDecorator('bID', {*/}
                {/*rules: [*/}
                {/*{*/}
                {/*required: true,*/}
                {/*message: '被保人身份证号码必须填写',*/}
                {/*},*/}
                {/*],*/}
                {/*})(<Input placeholder="必填"/>)}*/}
                {/*</FormItem>*/}
                {/*</div>) : null*/}
                {/*}*/}
              </Card>
              <Card className="pb-card" size="small" title="投保告知"
                    extra={<span className="i-link"
                                 onClick={() => this.handleOpenInform()}>{tongyi ? '（ 已阅读并同意 ）' : '（请点击阅读投保告知）'} &gt;</span>}>
                <Checkbox checked={tongyi} onChange={this.handleTYChange}>已阅读并同意以上告知</Checkbox>
              </Card>
              <Card className="pb-card" size="small" title="保费合计（元）" bodyStyle={{padding: 0}}
                    extra={<span style={{color: 'red'}}>￥{insurance_info.fixed_premium}</span>}>
                {/*<FormItem>*/}
                {/*{getFieldDecorator('daifu', {*/}
                {/*valuePropName: 'checked',*/}
                {/*})(*/}
                {/*<Checkbox>找人代付</Checkbox>*/}
                {/*)}*/}
                {/*</FormItem>*/}
              </Card>
              <Row style={{margin: '20px 0'}}>
                <Col span={6}>
                  <Button size="large" onClick={() => this.props.history.go(-1)}
                          block>返回</Button>
                </Col>
                <Col span={17} offset={1}>
                  <Button type="primary" size="large" htmlType="submit" loading={submit_loading}
                          block>确认购买</Button>
                </Col>
              </Row>
            </Form>
          </Spin>
          <div className="ib-footer">
            <Row gutter={20}>
              <Col span={12} className="fi-right">版权所有: 北京存心救援队</Col>
              <Col span={12} className="fi-left">技术支持及运营: 奥讯新媒体</Col>
              <Col span={12} className="fi-right">
                <a href="http://www.beian.miit.gov.cn" target="_blank">京ICP备16056531号</a>
              </Col>
              <Col span={12} className="fi-left">
                <a href={icp_png} target="_blank">ICP许可证 粤B2-20051036号</a>
              </Col>
            </Row>
          </div>
          <Drawer
            title="投保告知"
            placement="right"
            onClose={() => this.setData({inform_visible: false})}
            visible={inform_visible}
            width={800}
            maskClosable={false}
            getContainer={false}
            bodyStyle={{overflowY: 'auto', height: 'calc(100% - 55px)', padding: 15}}
          >
            <IInform auth={insurance_info.declare_auth || []}
                     onChange={(value) => this.setData({tongyi: value, inform_visible: false})}/>
          </Drawer>
        </div>
        <Modal
          title={(<div style={{textAlign: 'center'}}>产品详情</div>)}
          visible={detail_visible}
          width="80%"
          centered={true}
          onCancel={() => this.setData({detail_visible: false})}
          maskClosable={false}
          footer={(
            <div style={{textAlign: 'right'}}>
              <Button onClick={() => this.setData({detail_visible: false})}>关闭</Button>
            </div>
          )}
          destroyOnClose={true}>
          {/*<div dangerouslySetInnerHTML={{ __html: detail_html }}/>*/}
        </Modal>
      </div>
    );
  }
}

export default Form.create()(IBuy);



// WEBPACK FOOTER //
// ./src/routes/insure/IBuy.jsx